import type {
  InfoDownloadApiQuery,
  InvoiceApi,
  InvoicesListQuery,
  InvoicesSummaryApi,
  InvoicesSummaryApiQuery,
  InvoiceDownloadLinkApi,
  CustomerApi,
} from "@/Modules/Models/Api/Invoice";
import type { PaginatedApiResponse } from "@/Modules/App/Models/Api/PaginatedApiResponse";

import { get2, post2 } from "./utils/FunctionalTherapyApi";

export function getInvoicesSummary(
  invoicesSummaryParams: InvoicesSummaryApiQuery
): Promise<InvoicesSummaryApi> {
  return get2<InvoicesSummaryApiQuery, InvoicesSummaryApi>("v1.0/invoices-summary", {
    customer_uuid: invoicesSummaryParams.customer_uuid,
    customer_name: invoicesSummaryParams.customer_name,
  });
}

export function getInvoicesList(
  invoicesListQuery: InvoicesListQuery
): Promise<PaginatedApiResponse<InvoiceApi>> {
  return get2<InvoicesListQuery, PaginatedApiResponse<InvoiceApi>>(
    "v1.0/invoices",
    invoicesListQuery,
    undefined,
    { raw: true }
  );
}

export function getCustomersWithInvoicesList(): Promise<CustomerApi[]> {
  return get2<void, CustomerApi[]>("v1.0/invoices-customers");
}

export function downloadInvoices(infoDownload: InfoDownloadApiQuery): Promise<string> {
  return post2<InfoDownloadApiQuery, string>("v1.0/invoices/download", infoDownload);
}

export function getInvoiceDownloadLink(invoiceUuid: string): Promise<InvoiceDownloadLinkApi> {
  return get2<string, InvoiceDownloadLinkApi>(`/v1.0/invoices/${invoiceUuid}/pdf`);
}
